// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"input-switch_switchContainer__XYTBV"};